import { provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
// ─────────────────────────────────────────────────────────────────────────────
import * as Sentry from '@sentry/angular';

import { ConfigLoader, appConfig as environmentConfig } from './config-loader';

async function startApp() {
  // Initialize environment config
  await ConfigLoader.load();

  // Initialize Sentry before bootstrapping the application
  Sentry.init({
    dsn: 'https://edc6870038e442aba3c52587d8ce1be2@o4505322876174336.ingest.sentry.io/4505322892492800',
    // Called for message and error events
    beforeSendTransaction(event) {
      // Modify or drop the event here
      if (
        !environmentConfig.env.production ||
        event?.spans?.[0]?.description?.includes('pyodide')
      ) {
        return null;
      }

      return event;
    },
    sendClientReports: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/dev\.enlightenhq\.com\/api/,
      /^https:\/\/stage\.enlightenhq\.com\/api/,
    ],
    // Performance Monitoring
    tracesSampleRate: 0.5, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  // Use the bootstrapApplication from the standalone approach
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZonelessChangeDetection(), ...appConfig.providers],
  }).catch((err) => console.error(err));
}

startApp();
